"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxShadowTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const boxShadowNone = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'borderShadow-none',
    fallback: '0px'
});
const boxShadowS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'borderShadow-s',
    fallback: '0px 8px 16px 0px rgba(0, 0, 0, 0.20)'
});
exports.boxShadowTokens = {
    boxShadowS,
    boxShadowNone
};
//# sourceMappingURL=BoxShadow.js.map